import React, { useState } from 'react';
import { Header } from '../Header/Header';
import { Sidebar } from '../Sidebar/Sidebar';
import styles from './MainLayout.module.css';

interface MainLayoutProps {
  children: React.ReactNode;
  isAuthenticated: boolean;
  showSidebar?: boolean;
}

export const MainLayout: React.FC<MainLayoutProps> = ({
  children,
  isAuthenticated,
  showSidebar = true,
}) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <div className={styles.layout}>
      <Header 
        isAuthenticated={isAuthenticated} 
        onMenuToggle={toggleSidebar}
        showMenuButton={isAuthenticated && showSidebar}
      />
      
      {isAuthenticated && showSidebar ? (
        <>
          <div className={styles.contentWithSidebar}>
            <Sidebar 
              isOpen={isSidebarOpen} 
              onClose={closeSidebar}
            />
            <main className={styles.main}>{children}</main>
          </div>
          
          {/* Overlay para móvil */}
          {isSidebarOpen && (
            <div 
              className={styles.overlay} 
              onClick={closeSidebar}
              aria-hidden="true"
            />
          )}
        </>
      ) : (
        <main className={styles.mainFull}>{children}</main>
      )}
    </div>
  );
};

